import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { fetchPostByAuthor } from '../requests/author_request';

import Loader from '../components/Loader';

class AuthorPosts extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        if (willMount) {
            this.props.fetchPostByAuthor(this.props.id);
        }
    }

    renderPosts() {
        if (this.props.posts.fetched) {
            return this.props.posts.posts.map((post) => {
                return (
                    <article
                        key={post.id}
                        id={`post-${post.id}`}
                        className={`post-${post.id} author-article image-bg fadeIn`}>
                        <div className="post-container">
                            {post.better_featured_image ? (
                                <div className="image-container">
                                    <picture>
                                        <source
                                            media="(max-width: 767px)"
                                            srcSet={
                                                post.better_featured_image
                                                    .media_details.sizes
                                                    .img_overview_half
                                                    .source_url
                                            }
                                        />
                                        <img
                                            className="img-responsive"
                                            src={
                                                post.better_featured_image
                                                    .media_details.sizes
                                                    .img_overview_wide
                                                    .source_url
                                            }
                                            alt={`featured ${post.title.rendered} Friends for Brands`}
                                        />
                                    </picture>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className="title-container">
                                <h2>{post.title.rendered}</h2>
                                <Link
                                    className="cta-btn"
                                    to={{
                                        pathname: `/${post.acf.type}/${post.slug}`,
                                        state: { transition: 'fade' },
                                    }}>
                                    Bekijk case
                                </Link>
                            </div>
                        </div>
                    </article>
                );
            });
        } else {
            return '';
        }
    }

    render() {
        return (
            <div>
                <Loader loaded={this.props.posts.fetched} />
                <div id="overview">{this.renderPosts()}</div>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchPostByAuthor })(AuthorPosts)
);



// WEBPACK FOOTER //
// ./src/containers/AuthorPosts.jsx